/// <reference path="Assistant.ts" />

namespace TerminalApp {


    export class AddressFormAssistant extends Assistant {
        bc_menu = document.createElement("div");
        submit_button: HTMLElement;

        current: SP.OrderInfo;

        name_input: HTMLInputElement;
        attention_input: HTMLInputElement;
        address1_input: HTMLInputElement;
        address2_input: HTMLInputElement;
        zipCode_input: HTMLInputElement;
        city_input: HTMLInputElement;
        country_input: HTMLInputElement;
        state_input: HTMLInputElement;
        phone_input: HTMLInputElement;
        email_input: HTMLInputElement;

        constructor() {
            super();

            this.initialize();

            this.submit_button = this.bc_menu.querySelector(".btn");
            this.submit_button.addEventListener("click", async () => {
                SP.Sounds.Click.play();

                var postData = {
                    id: this.current.orderId,

                    recipient: {
                        name: this.name_input.value,
                        attention: this.attention_input.value,
                        street1: this.address1_input.value,
                        street2: this.address2_input.value,
                        zipcode: this.zipCode_input.value,
                        city: this.city_input.value,
                        country: this.country_input.value,
                        state: this.state_input.value,
                        phone: this.phone_input.value,
                        email: this.email_input.value
                    }

                };

                let result = await SP.post<any>("/api/v1/order/update", postData);

                if (result.status == 200) {
                    this.current.recipient = postData.recipient;
                }

                this.close();
            });

        }

        hide() {
            this.bc_menu.style.display = "none";
        }

        open_bc() {
            this.hide();
            this.container.style.display = "block";
            this.bc_menu.style.display = "block";
        }

        async open(order: SP.OrderInfo) {
            this.reset();
            this.current = order;

            this.name_input.value = order.recipient.name;
            this.attention_input.value = order.recipient.attention;
            this.address1_input.value = order.recipient.street1;
            this.address2_input.value = order.recipient.street2;
            this.zipCode_input.value = order.recipient.zipcode;
            this.city_input.value = order.recipient.city;
            this.country_input.value = order.recipient.country;
            this.state_input.value = order.recipient.state;
            this.phone_input.value = order.recipient.phone;
            this.email_input.value = order.recipient.email;

            this.open_bc();
        }

        close() {
            this.reset();
            super.close();
        }

        reset() {
            this.name_input.value = "";
            this.attention_input.value = "";
            this.address1_input.value = "";
            this.address2_input.value = "";
            this.zipCode_input.value = "";
            this.city_input.value = "";
            this.country_input.value = "";
            this.state_input.value = "";
            this.phone_input.value = "";
            this.email_input.value = "";
        }

        initialize() {

            this.bc_menu.innerHTML = `

                <div class="setting_group setting_group-custom">
                    
                    <div class="setting-custom">
                    <h1 class="terminal-modal-h1">${SP.Localize("sentance_edit_address")}</h1>    

                        <div class="terminal-form-input-container">
                            <input class="terminal-form-input orderInfo-terminal-form-name" type="text" placeholder="${SP.Localize("word_name")}" />
                        </div>

                        <div class="terminal-form-input-container">
                            <input class="terminal-form-input orderInfo-terminal-form-attention" type="text" placeholder="${SP.Localize("word_attention")}" />
                        </div>

                        <div class="terminal-form-input-container">
                            <input class="terminal-form-input orderInfo-terminal-form-address1" type="text" placeholder="${SP.Localize("word_address")} 1" />
                        </div>

                        <div class="terminal-form-input-container">
                            <input class="terminal-form-input orderInfo-terminal-form-address2" type="text" placeholder="${SP.Localize("word_address")} 2" />
                        </div>

                        <div class="terminal-form-input-container terminal-d-flex terminal-align-items-center terminal-justify-content-between">
                            <input class="terminal-form-input orderInfo-terminal-form-zipCode" type="text" placeholder="${SP.Localize("word_zipCode")}" />

                            <input class="terminal-form-input orderInfo-terminal-form-city" type="text" placeholder="${SP.Localize("word_city")}" />
                        </div>

                        <div class="terminal-form-input-container">
                            <input class="terminal-form-input orderInfo-terminal-form-country" type="text" placeholder="${SP.Localize("word_country")}" />
                        </div>

                        <div class="terminal-form-input-container">
                            <input class="terminal-form-input orderInfo-terminal-form-state" type="text" placeholder="${SP.Localize("word_state")}" />
                        </div>

                        <div class="terminal-form-input-container">
                            <input class="terminal-form-input orderInfo-terminal-form-phone" type="text" placeholder="${SP.Localize("word_phone")}" />
                        </div>

                        <div class="terminal-form-input-container">
                            <input class="terminal-form-input orderInfo-terminal-form-email" type="text" placeholder="${SP.Localize("word_email")}" />
                        </div>

                    </div>
                </div>

                <div class="btn noselect grad-green"><span class="action">${SP.Localize("word_save")}</span></div>
            `;

            this.name_input = this.bc_menu.querySelector(".orderInfo-terminal-form-name");
            this.attention_input = this.bc_menu.querySelector(".orderInfo-terminal-form-attention");
            this.address1_input = this.bc_menu.querySelector(".orderInfo-terminal-form-address1");
            this.address2_input = this.bc_menu.querySelector(".orderInfo-terminal-form-address2");
            this.zipCode_input = this.bc_menu.querySelector(".orderInfo-terminal-form-zipCode");
            this.city_input = this.bc_menu.querySelector(".orderInfo-terminal-form-city");
            this.country_input = this.bc_menu.querySelector(".orderInfo-terminal-form-country");
            this.state_input = this.bc_menu.querySelector(".orderInfo-terminal-form-state");
            this.phone_input = this.bc_menu.querySelector(".orderInfo-terminal-form-phone");
            this.email_input = this.bc_menu.querySelector(".orderInfo-terminal-form-email");

            this.container.appendChild(this.bc_menu);
        }

    }
}